import { Button, Card, Heading, Text, ThemeToggle } from "@microbeta/ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { MetaTags } from "../../../../shared/components";
import { useAnalytics } from "../../../../shared/hooks";
import { paths } from "../../../../shared/utils/routing";
import { useAuthContext } from "../../AuthContext";
import background from "../../assets/images/background.svg";
import { RecaptchaNotice } from "../../components/RecaptchaNotice";
import { SignInGoogleButton } from "../../components/SignInGoogleButton";
import styles from "./signin.module.scss";

const SignInPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { signInWithGoogle } = useAuthContext();
  const { trackPageView } = useAnalytics();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirectUrl");
  console.log(`SignInPage: redirectUrl from params: ${redirectUrl}`);

  useEffect(() => {
    trackPageView("signin_page");
  }, [trackPageView]);

  const handleEmailSignIn = () => {
    navigate(
      redirectUrl
        ? `${paths.emailSignIn}?redirectUrl=${redirectUrl}`
        : paths.emailSignIn
    );
  };

  const handleGoogleSignIn = () => {
    signInWithGoogle(redirectUrl ?? undefined);
  };

  return (
    <div className={styles.container}>
      <MetaTags
        title="Sign In to Microbeta"
        description="Sign in to Microbeta to discover amazing climbing areas, track your climbing progress, and share your adventures with the climbing community."
        keywords="sign in, login, climbing, rock climbing, modeling, climbing community"
        noIndex={true}
        noFollow={true}
      />
      <img src={background} alt="background" className={styles.backgroundImg} />

      {/* Theme Toggle - positioned in top-right corner */}
      <div className={styles.themeToggleContainer}>
        <ThemeToggle size="md" />
      </div>

      <Card className={styles.card}>
        <Heading variant="medium" className={styles.title}>
          {t("signIn.microbeta")}
        </Heading>
        <Text variant="large" className={styles.description}>
          {t("signIn.description")}
        </Text>
        <SignInGoogleButton
          className={styles.button}
          onClick={handleGoogleSignIn}
        />
        <Button
          className={styles.button}
          variant="primary"
          onClick={handleEmailSignIn}
        >
          {t("signIn.signInWithEmail")}
        </Button>
        <Text variant="small">
          {t("signIn.dontHaveAccount")}
          <Link
            to={
              redirectUrl
                ? `${paths.signup}?redirectUrl=${redirectUrl}`
                : paths.signup
            }
          >
            <Text className={styles.signUpLinkText} as="span" variant="small">
              {t("signIn.signUpHere")}
            </Text>
          </Link>
        </Text>
        <RecaptchaNotice />
      </Card>
    </div>
  );
};

export default SignInPage;
